import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Reports.redux';
import DeletePopover from 'components/DeletePopover';

const ReportsCell = (params) => {
    const { field, row } = params;
    const id = row.urpt_id;
    const dispatch = useDispatch();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeleteReport = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeleteReport = useCallback(() => {
        dispatch(actions.loadReports(true));
        setActionsOpen(false);
    }, [dispatch]);

    if (field !== 'actions') {
        return null;
    }

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Button
                variant="outlined"
                size="large"
                onClick={(event) => {
                    actionAnchor.current = event.currentTarget;
                    setActionsOpen(true);
                }}
            >
                ...
            </Button>
            <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                <MenuItem>
                    <DeletePopover
                        objectType="REPORT"
                        objectID={id}
                        afterDelete={afterDeleteReport}
                        beforeDelete={beforeDeleteReport}
                    >
                        <Button variant="text" size="large" color="error">
                            Delete Report
                        </Button>
                    </DeletePopover>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ReportsCell;
